import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqComponent } from './faq.component';
import { SupportComponent } from './support/support.component';
import { RouterModule } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { SupportTicketModalModule } from './support-ticket-modal/support-ticket-modal.module';
import { FilestackService } from '@hiptraveler/core/filestack';

const MODULES = [
  CommonModule, 
  MatExpansionModule, 
  MatIconModule, 
  MatButtonModule, 
  MatDialogModule,
  SupportTicketModalModule
];

const COMPONENTS = [FaqComponent, SupportComponent];

const PROVIDERS = [FilestackService];

@NgModule({
  imports: [
    MODULES,
    RouterModule.forChild([
      {
        path: '',
        component: FaqComponent,
      },
    ]),
  ],
  declarations: [COMPONENTS],
  providers: [PROVIDERS],
})
export class FaqModule {}
